/* eslint-disable no-unused-vars */

const AppConsts = {
  localization: {
    defaultLocalizationSourceName: 'Pos',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  version: '1.0.1',
  licenseUrl: 'https://www.eimspk.com/',
  appBaseUrl: 'http://localhost:3000',
};
export default AppConsts;

// Delete node_modules
// npm i --ignore-script --legacy-peer-deps
// npm install --legacy-peer-deps
